<div class="nav-padding"></div>
<mat-toolbar class="header-landing">
  <button
    mat-icon-button
    class="mobile-burger"
    [matMenuTriggerFor]="hamburgerMenu"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <app-logo
    class="logo-wrapper"
    [link]="homePage"
  />

  @if (showScrollButtons) {
    <button
      mat-icon-button
      class="scroll-button"
      (mousedown)="startMenuScrolling('left')"
      (mouseup)="stopScroll()"
      (mouseleave)="stopScroll()"
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
  }

  <div
    #desktopMenu
    class="text-menu-items"
  >
    @for (item of menuItems; track item) {
      <app-header-menu-item
        data-test="header-menu-item"
        [menuItem]="item"
        (closeTooltip)="markTooltipAsVisited(item.name)"
      />
    }
  </div>

  @if (showScrollButtons) {
    <button
      mat-icon-button
      class="scroll-button"
      (mousedown)="startMenuScrolling('right')"
      (mouseup)="stopScroll()"
      (mouseleave)="stopScroll()"
    >
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  }

  <app-header-account-panel [user]="user" />
</mat-toolbar>

<mat-menu #hamburgerMenu="matMenu">
  @for (item of menuItems; track item) {
    <a
      *appPermission="item.permission; and: item.condition"
      mat-menu-item
      routerLinkActive="active"
      [routerLink]="item.link"
    >
      {{ item.name }}
    </a>
  }
  @if (companyType) {
    <a
      mat-menu-item
      routerLinkActive="active"
      routerLink="/messages"
    >
      Messages
    </a>
  }
  <a
    mat-menu-item
    routerLinkActive="active"
    routerLink="/company-profile"
  >
    Profile
  </a>
  <a
    mat-menu-item
    routerLinkActive="active"
    routerLink="/user"
  >
    Settings
  </a>
  @if (companyType) {
    <a
      mat-menu-item
      (click)="logout()"
    >
      Log Out
    </a>
  }
</mat-menu>
